import { MarketingButtonAction } from '../shared/enums/marketing.enums';

export enum MarketingTrayButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
}

export interface MarketingCtaProgramData {
  availabilityFrom?: string;
  availabilityTo?: string;
  episode?: boolean;
  id: number;
  season?: boolean;
  title?: string;
}

export interface MarketingTrayButton {
  buttonType: MarketingTrayButtonType;
  action: MarketingButtonAction;
  buttonTextEnglish: string;
  buttonTextArabic: string;
  buttonActionPageTargetId?: string;
  buttonActionExternalUrl?: string;
  buttonActionProgramTarget?: MarketingCtaProgramData;
}
